
import { Injectable, enableProdMode } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })// singelton

export class versionUpdatesVerifierService {

  public _version: string;

  constructor(public _ConfigService: ConfigService, private _http: HttpClient, public _router: Router/*, private _AuthService: AuthServiceGuest*/)
  {
  }

  public initVersionCheck(frequency = 1000 * 10)
  {
    this.getIfNewerVersion();
    //allows us to run a function once after the interval of time - after login - only once
    // the token will inspire after 1 hour after login - so the version will be checked at least after one hour
    setTimeout(() => {
      this.getIfNewerVersion();
    }, frequency);
  }

  getIfNewerVersion() {

    const self = this;
    this._http.get('/assets/version.json')
      .toPromise()
      .then(data => {

        const currentVersion = localStorage.getItem('version');
        console.log('getIfNewerVersion currentVersion ' + currentVersion);

        self._version = data['version'];
        console.log('getIfNewerVersion data version ' + self._version);
        localStorage.setItem('version', self._version);

        if (self._version != currentVersion) {
          // Alex prevent reloads 

          location.reload();
        }
        error => { }
      });
  }
}

export interface Version {
  version: string;

}
